import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const PasswordModal = ({ newPassword, setNewPassword, onSave, onCancel }) => {
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  // focus input on open + lock background scroll
  useEffect(() => {
    inputRef.current?.focus();
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  // close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
      if (e.key === "Enter") onSave?.(); // optional: Enter submits
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel, onSave]);

  // click outside to close
  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onCancel?.();
  };

  const modal = (
    <div
      className="modal-backdrop"
      onClick={onBackdropClick}
      aria-hidden={false}
    >
      <div
        className="modal-box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pwd-title"
        ref={modalRef}
      >
        <h3 id="pwd-title" className="modal-title">
          Change Password
        </h3>

        <input
          ref={inputRef}
          type="password"
          className="form-input"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
        />

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={onSave}>
            Save
          </button>
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );

  // Render above everything
  return createPortal(modal, document.body);
};

export default PasswordModal;


